export const strings = {
    customiseReport: 'Customise your report',
    downloadReport: 'Download report',
    startNewReport: 'Start new report',
    back: 'Back',
    reportDownloadInProgressMessage: 'Please wait. The report may take up to a few minutes to download.',
    reportDownloadCompleteMessage: 'Report downloaded. Check your downloads folder.',
};
